export class TargetPlaylistItemDTO {
    title: string;
    artist: string;
    album: string;
    url: string;
    probability: string;
    itemGroup: string;
    dateCreated: string;

    constructor(json: any) {
        this.title = json.title;
        this.artist = json.artist;
        this.album = json.album;
        this.url = json.url;
        this.probability = json.probability;
        this.itemGroup = json.itemGroup;
        this.dateCreated = json.dateCreated;
    }
}